import React, { useState, useEffect } from 'react'
import { REPOSITORY } from '../../api/repository/Repository'
import { useNavigate } from 'react-router-dom'
import {
  VStack,
  Box,
  Input,
  Button,
  Flex,
  Icon,
  InputLeftElement,
  InputRightElement,
  InputGroup,
  IconButton,
  List,
  ListItem,
  ListIcon,
  FormControl,
  FormLabel,
  useDisclosure,
} from '@chakra-ui/react'

import CheckIcon from '../../components/SvgIcon/icons/CheckIcon'
import CloseIcon from '../../components/SvgIcon/icons/CloseIcon'
import ViewIcon from '../../components/SvgIcon/icons/ViewIcon'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import KeyIcon from '../../components/SvgIcon/icons/KeyIcon'
import { colors } from '../../utils/theme/styles'
import ChangePasswordPopup from '../ChangePassword/ChangePasswordPopup'

export default function ChangePassword() {
  const [data, setData] = useState([])
  const navigate = useNavigate()

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [status, setStatus] = useState('')

  const containsUpperCase = (str) => /[A-Z]/.test(str)
  const containsLowerCase = (str) => /[a-z]/.test(str)
  const containsNumber = (str) => /[0-9]/.test(str)
  const isLessThanSixCharacters = (str) => str.length < 6

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value
    setPassword(newPassword)
  }

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value)
  }

  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword)
  }

  const handleChangePassword = (password, confirmPassword) => {
    REPOSITORY.wsEmpresa.password
      .cambioContrasenaEmpresa_PrimerLogin({
        sClaveNueva: password,
        sClaveNuevaConfirm: confirmPassword,
      })
      .then((response) => {
        if (response.status === 200) {
          setStatus('success')
          onOpen()
        }
      })
      .catch((error) => {
        if (error.response) {
          setStatus('error')
          onOpen()
        }
      })
  }

  const handleFetch = async () => {
    await REPOSITORY.wsEmpresa.employees.getContacts().then((res) => {
      setData(res.data)
    })
  }
  const allConditionsMet = () =>
    containsUpperCase(password) &&
    containsLowerCase(password) &&
    containsNumber(password) &&
    !isLessThanSixCharacters(password) &&
    password === confirmPassword

  const onClick = (value) => {
    navigate(`${value}`)
  }

  useEffect(() => {
    handleFetch()
  }, [])

  return (
    <Box
      display="inline-flex"
      flexDirection="column"
      alignItems="flex-start"
      gap="10px"
      mb="100px"
      w="100%"
    >
      <VStack w="100%" alignItems="flex-start" mb="100px" spacing="24px">
        <UnderlineHeading
          text="Cambio de contraseña"
          variant="h5"
          color={colors.gray[800]}
        />

        <Box p="25px" w="100%" boxShadow="-9px 14px 44px rgba(0, 0, 0, 0)">
          <VStack spacing="20px" alignItems="flex-start" width="346px">
            <Flex w="100%" justify="space-between" gap="30px">
              <FormControl position="relative">
                <FormLabel
                  position="absolute"
                  top="-8px"
                  left="10px"
                  bg="white"
                  px={2}
                  fontSize="sm"
                  fontWeight="bold"
                  zIndex={1}
                >
                  Ingresa una nueva clave
                </FormLabel>
                <InputGroup
                  style={{
                    width: '346px',
                    height: '40px',
                  }}
                >
                  <InputLeftElement
                    pointerEvents="none"
                    children={<KeyIcon color="gray.300" />}
                  />
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={handlePasswordChange}
                    focusBorderColor="var(--Neutros-gris-900, #565656)"
                  />
                  <InputRightElement>
                    <IconButton
                      icon={showPassword ? <ViewIcon /> : <ViewIcon />}
                      onClick={toggleShowPassword}
                      variant="ghost"
                    />
                  </InputRightElement>
                </InputGroup>
                <List spacing={1} mt="15px">
                  <ListItem display="flex" alignItems="center">
                    <ListIcon
                      as={containsUpperCase(password) ? CheckIcon : CloseIcon}
                      color={
                        containsUpperCase(password) ? 'green.500' : 'red.500'
                      }
                    />
                    Contiene mayúsculas
                  </ListItem>
                  <ListItem display="flex" alignItems="center">
                    <ListIcon
                      as={containsLowerCase(password) ? CheckIcon : CloseIcon}
                      color={
                        containsLowerCase(password) ? 'green.500' : 'red.500'
                      }
                    />
                    Contiene minúsculas
                  </ListItem>
                  <ListItem display="flex" alignItems="center">
                    <ListIcon
                      as={containsNumber(password) ? CheckIcon : CloseIcon}
                      color={containsNumber(password) ? 'green.500' : 'red.500'}
                    />
                    Contiene números
                  </ListItem>
                  <ListItem display="flex" alignItems="center">
                    <ListIcon
                      as={
                        !isLessThanSixCharacters(password)
                          ? CheckIcon
                          : CloseIcon
                      }
                      color={
                        !isLessThanSixCharacters(password)
                          ? 'green.500'
                          : 'red.500'
                      }
                    />
                    Tiene al menos 6 caracteres
                  </ListItem>
                </List>
              </FormControl>
              <FormControl position="relative">
                <FormLabel
                  position="absolute"
                  top="-8px"
                  left="10px"
                  bg="white"
                  px={2}
                  fontSize="sm"
                  fontWeight="bold"
                  zIndex={1}
                >
                  Confirma tu nueva clave
                </FormLabel>
                <InputGroup
                  style={{
                    width: '346px',
                    height: '40px',
                  }}
                >
                  <InputLeftElement pointerEvents="none">
                    <Icon as={KeyIcon} color="gray.500" />
                  </InputLeftElement>
                  <Input
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    focusBorderColor="var(--Neutros-gris-900, #565656)"
                  />
                  <InputRightElement>
                    <IconButton
                      icon={showConfirmPassword ? <ViewIcon /> : <ViewIcon />}
                      onClick={toggleShowConfirmPassword}
                      variant="ghost"
                    />
                  </InputRightElement>
                </InputGroup>
                <List spacing={1} mt="15px">
                  <ListItem display="flex" alignItems="center">
                    <ListIcon
                      as={password !== confirmPassword ? CloseIcon : CheckIcon}
                      color={
                        password !== confirmPassword ? 'red.500' : 'green.500'
                      }
                    />
                    Contraseñas no coinciden
                  </ListItem>
                </List>
              </FormControl>
              <Button
                variant={'grayNoRadius'}
                display="flex"
                width="354px"
                height="40px"
                justifyContent="center"
                alignItems="center"
                flexShrink="0"
                borderRadius="md"
                bg={allConditionsMet() ? '#EFA329' : 'gray.300'}
                isDisabled={!allConditionsMet()}
                onClick={() => handleChangePassword(password, confirmPassword)}
              >
                CAMBIAR CLAVE
              </Button>
            </Flex>
          </VStack>
        </Box>
      </VStack>
      <ChangePasswordPopup isOpen={isOpen} onClose={onClose} status={status} />
    </Box>
  )
}
